<template>
    <div class="container-fluid">
      <div class="row">
        <div class="col-6 text-left">          
              <img class="logopic" src="@/assets/images/logo.png" >          
        </div>
        <div class="col-6 text-right" >
          <nav class="navbar">
              <router-link v-for="(nav,index) in navs" :key="index" :to="nav.url" class="nav-item">
                  <label>{{nav.name}}</label>
                  <i class="navline"></i>
              </router-link>
          </nav>      
        </div>
      </div>
      <div class="row">
        <div class="col-12">
           <Banner/>
        </div>
      </div>
    </div>
</template>
<script>       
import Banner from '@/components/Banner';
export default {
   data(){
     return{
       navs:[
         {url:'/home',name:'首页'},
         {url:'/program',name:'易梵编程'},
         {url:'/product',name:'产品与服务'},          
         {url:'/about',name:'关于我们'},
         {url:'/contact',name:'联系我们'},
       ],
       
     }
   } ,    
   components:{
     Banner
   }
   
}    

</script>
<style scoped>
   .nav-item{
      color: #1d1c1c;
      font-size:18px;
      padding: 20px;
      position: relative;
   } 
   .nav-item:hover:before{
      content: '';
      bottom:-6px;
      position:absolute;
      left:0;
      width:100%;
      height:2px;
      opacity: 1;
      background-color: #f00;
      transition: .3s;
   }  
   .navline{
      position: absolute;
      left: 0;     
      height: 2px;
      transition: .3s;
   }  
   .logopic{
     height:auto;
     width:200px;
     margin:10px 50px;
   }
   .active{
     color: red;
   }
   
</style>